export default __webpack_public_path__ + "static/f1-fa398c8256b1f93b854a83877a419608.png";